import React from 'react';
import Router from 'next/router';
import Container from '@lendi-ui/container';
import { Category } from '../../utils/schema';
import { eventTracking } from '../../utils';
import { InspireTab, InspireTabs, TabsWrapper } from './index.style';

export interface CategoryTabsProps {
  categories: Category[];
  category?: Category;
}

interface CategoryTabsState {
  categories: CategoryLink[];
}

interface CategoryLink {
  title: string;
  as: string;
  href: string;
}

export class CategoryTabs extends React.Component<CategoryTabsProps, CategoryTabsState> {
  constructor(props: CategoryTabsProps) {
    super(props);

    const categories = [
      { title: 'Inspire Home', as: '/inspire', href: '/' },
      ...this.props.categories.map((category) => ({
        title: category.name,
        as: `/inspire/category/${category.slug}`,
        href: `/?category=${category.slug}`,
      })),
    ];

    this.state = {
      categories,
    };
  }

  componentDidMount() {
    this.state.categories.forEach(({ href }) => Router.prefetch(href));
  }

  onTabClick = (clickedTabIndex: number) => {
    const category = this.state.categories[clickedTabIndex];
    eventTracking('above-fold', 'navigate', category.title);
  };

  render() {
    const category = this.props.category;
    // +2: tabs are 1-indexed (+1) and Inspire tab is pushed at the front (+2)
    const activeTabIndex = category ? this.props.categories.findIndex((c) => c.id === category.id) + 1 : 0;
    return (
      <TabsWrapper>
        <Container>
          <InspireTabs onChangeTabIndex={this.onTabClick} activeTabIndex={activeTabIndex} isInverse>
            {this.state.categories.map((category) => (
              <InspireTab key={category.href} href={category.as}>
                {category.title}
              </InspireTab>
            ))}
          </InspireTabs>
        </Container>
      </TabsWrapper>
    );
  }
}
